<template>
  <div class="page-wrap">
    <div v-if="finsh" class="page-container finsh-wrap">
      <div class="finsh-icon">
        <fps-icon type="check" size="30" color="#38BA7C" />
      </div>
      <div class="finsh-title">{{$t('upgrade_page_views_withdraw_index_1552')}}</div>
      <div class="finsh-card-title">{{$t('upgrade_page_views_withdraw_index_1553', [ pricing ])}}</div>
      <div class="finsh-card-title">{{$t('upgrade_page_views_withdraw_index_1554')}}<a href="https://www.newebpay.com/" target="_black"
          >{{$t('upgrade_page_views_withdraw_index_1555')}}</a
        >{{$t('upgrade_page_views_withdraw_index_1556')}}</div>
      <button class="back-btn" @click="backWithdraw">{{$t('upgrade_page_layout_index_1123')}}</button>
      <p @click="jumpGuide">{{$t('upgrade_page_views_withdraw_index_1582')}}</p>
    </div>
    <div v-else class="page-container">
      <div class="page-title">
        <div
          v-for="(o, i) in tabs"
          :key="'tab-' + i"
          class="tab-one"
          :class="o.component === withdrawTab && 'active'"
          @click="withdrawTab = o.component"
        >
          <span class="tab-icon" v-if="o.icon">{{ o.icon }}</span>
          <span class="tab-title">{{ o.title }}</span>
          <span class="tab-tip">{{ o.tip }}</span>
        </div>
      </div>
      <div v-show="withdrawTab === 'none'" class="page-content">
        <div class="money-wrap">
          <span>{{$t('upgrade_page_views_withdraw_index_1557')}}</span>
          <span class="money"> $ {{ accountInfo.reward }} </span>
        </div>
        <div class="input-wrap">
          <div class="input-title">{{$t('upgrade_page_views_withdraw_index_1558')}}</div>
          <div class="input-content">
            <input
              v-model="price"
              type="number"
              min="0"
              :placeholder="$t('upgrade_page_views_withdraw_index_1559')"
              @change="moneyChange"
              @input="inputMoney"
            />
            <div class="tip-wrap">
              <p>{{$t('upgrade_page_views_withdraw_index_1560')}}</p>
              <p>{{$t('upgrade_page_views_withdraw_index_1561')}}</p>
              <p>{{$t('upgrade_page_views_withdraw_index_1562')}}</p>
              <p>{{$t('upgrade_page_views_withdraw_index_1563')}}</p>
            </div>
            <div v-if="showPriceError" class="money-error">{{ errorMsg }}</div>
          </div>
        </div>
        <div class="input-wrap">
          <div class="input-title">{{$t('upgrade_page_views_withdraw_index_1564')}}</div>
          <div class="input-content">
            <div v-if="isLoading" class="loading-wrap">
              <i class="el-icon-loading"></i>
            </div>
            <div v-else-if="lanxinInfo" class="lanxin-info">
              <div class="text-wrap">
                <div class="info-label">{{$t('upgrade_page_views_withdraw_index_1565')}}</div>
                <div class="info-value">{{ lanxinInfo.memberName }}</div>
                <div class="info-label">{{$t('upgrade_page_views_withdraw_index_1566')}}</div>
                <div class="info-value">
                  {{ lanxinInfo.bankCode | bankNameParse }}
                </div>
                <div class="info-label">{{$t('upgrade_page_views_withdraw_index_1567')}}</div>
                <div class="info-value">{{ lanxinInfo.subBankCode }}</div>
                <div class="info-label">{{$t('upgrade_page_views_withdraw_index_1568')}}</div>
                <div class="info-value">
                  {{ lanxinInfo.bankAccount | bankAccountParse }}
                </div>
              </div>
              <div class="tip-wrap">
                <p>{{$t('upgrade_page_views_withdraw_index_1569')}}</p>
                <p>{{$t('upgrade_page_views_withdraw_index_1570')}}</p>
              </div>
            </div>
            <div v-else class="add-lanxin-info" @click="addInfo">
              <fps-icon type="add" size="18" />
              <span>{{$t('upgrade_page_views_withdraw_index_1571')}}</span>
            </div>
          </div>
        </div>
        <div class="read-rules">
          <div
            class="circle-wrap"
            :class="selectRead && 'selected'"
            @click="selectRead = !selectRead"
          >
            <fps-icon v-if="selectRead" type="check" size="12" />
          </div>
          <div class="text">{{$t('upgrade_page_views_settled_in_before_settled_1136')}}<span class="light" @click="open">{{$t('upgrade_page_views_withdraw_index_1572')}}</span>。
          </div>
        </div>
        <button
          class="withdraw-btn"
          :disabled="showPriceError || !lanxinInfo || !selectRead"
          @click="withdrawSubmit"
        >
          <i v-if="submiting" class="el-icon-loading"></i>
          <span v-else>{{$t('upgrade_page_views_withdraw_index_1573')}}</span>
        </button>
      </div>
      <withdrawATM
        v-show="withdrawTab === 'withdrawATM'"
        :lanxinInfo="lanxinInfo"
        :price="price"
        @handleFinsh="handleFinsh"
      />
      <WithdrawBenefit
        v-show="withdrawTab === 'WithdrawBenefit'"
        :isShow="withdrawTab === 'WithdrawBenefit'"
      />
      <el-dialog
        :title="$t('upgrade_page_views_withdraw_index_1572')"
        :visible.sync="dialogVisible"
        width="418px"
        :append-to-body="true"
        class="dislogmethods"
      >
        <div class="divider_mthods"></div>
        <!-- <div>
          1. 依據臺灣相關法律規定，申請提領的用戶提供相關所需文件以利nicee官方協助完成勞務報酬單填寫，首次進行提現流程時，會需要上傳您的身份證正反面，若資料上有任何問題，nicee官方將與您聯繫相關事宜。 
        </div> -->
        <div>{{$t('upgrade_page_views_withdraw_index_1574')}}</div>
        <div>{{$t('upgrade_page_views_withdraw_index_1575')}}</div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import i18n from '@/locales/index'
import { mapGetters } from 'vuex';
import WithdrawBenefit from '@/upgrade-page/views/withdrawalBenfit/withdrawalBenefit';
import withdrawATM from '@/upgrade-page/views/withdrawalBenfit/withdrawATM';
import bankName from '@/upgrade-page/views/withdrawalBenfit/bank';
export default {
  name: 'Withdraw',
  filters: {
    bankNameParse(code) {
      const rs = bankName.find(item => item.bankCode === code);
      return rs ? rs.bankName : code;
    },
    bankAccountParse(text) {
      if (!text) return;
      const list = text.split('');
      return list.reduce((rs, item, index, array) => {
        if (index < array.length - 4) {
          rs += '*';
        } else {
          rs += item;
        }
        return rs;
      }, '');
    }
  },
  components: {
    WithdrawBenefit,
    withdrawATM
  },
  data() {
    let price = window.sessionStorage.getItem('LAST_INPNT_PRICE') || '';
    if (price) {
      window.sessionStorage.removeItem('LAST_INPNT_PRICE');
    }
    return {
      selectRead: false,
      price,
      isLoading: true,
      lanxinInfo: null,
      dialogVisible: false,
      showPriceError: false,
      errorMsg: '',
      submiting: false,
      withdrawTab: 'WithdrawBenefit',
      tabs: [
        // {
        //   title: '自助提領',
        //   tip: '2~6個工作日, 限免手續費',
        //   component: 'withdrawATM',
        // },
        {
          icon: i18n.t('upgrade_page_views_feed_list_index_1417'),
          title: i18n.t('upgrade_page_views_withdraw_index_1576'),
          tip: i18n.t('upgrade_page_views_withdraw_index_1577'),
          component: 'WithdrawBenefit'
        }
      ],
      finsh: false,
      submitTime: ''
    };
  },
  computed: {
    ...mapGetters(['accountInfo', 'userPermissions']),
    pricing() {
      return window.sessionStorage.getItem('LAST_INPNT_PRICE');
    }
  },
  watch: {
    userPermissions() {
      this.addTabs();
    }
  },
  methods: {
    jumpGuide() {
      this.$router.push('/withdraw-guide');
    },
    // 提交提領申請
    handleFinsh(value) {
      this.finsh = value;
    },
    addTabs() {
      if (
        this.userPermissions &&
        this.userPermissions.lanXinWithdraw === 'Open' &&
        this.tabs.length < 2
      ) {
      //临时屏蔽
        // this.tabs.push({
        //   title: '自助提領',
        //   tip: '10~15個工作日',
        //   component: 'withdrawATM'
        // });
        // this.withdrawTab = 'withdrawATM';
      } else if (
        this.userPermissions &&
        this.userPermissions.lanXinWithdraw !== undefined
      ) {
        this.withdrawTab = 'WithdrawBenefit';
      }
    },
    backWithdraw() {
      this.finsh = false;
      this.price = '';
      this.selectRead = false;
    },
    parseTime(time) {
      const d = time ? new Date(time) : new Date();
      let month = d.getMonth() + 1;
      if (month < 10) month = '0' + month;
      let day = d.getDate();
      if (day < 10) day = '0' + day;
      let hour = d.getHours();
      if (hour < 10) hour = '0' + hour;
      let minute = d.getMinutes();
      if (minute < 10) minute = '0' + minute;
      let second = d.getSeconds();
      if (second < 10) second = '0' + second;
      return `${d.getFullYear()}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    withdrawSubmit() {
      if (this.submiting) return;
      this.submiting = true;
      this.$http
        .post('/withdraw/lanxin/withdraw', {
          accountKind: 'Reward',
          currencyKind: 'TWD',
          amount: this.price
        })
        .then(() => {
          this.finsh = true;
          this.submiting = false;
          this.submitTime = this.parseTime();
          this.$store.dispatch('app/getUserAccount');
        })
        .catch(() => {
          this.submiting = false;
        });
    },
    addInfo() {
      window.sessionStorage.setItem('LAST_INPNT_PRICE', this.price);
      this.$router.push({
        name: 'WithdrawInfo'
      });
    },
    getWithdrawInfo() {
      this.$http.get('/withdraw/bank/get').then(({ data }) => {
        this.isLoading = false;
        if (data) {
          this.lanxinInfo = {
            ...data.bankInfo,
            lastWithdraw: data.lastWithdraw
          };
        }
      });
    },
    inputMoney() {
      const price = +this.price;
      if (price < 0) this.price = 0;
      else this.price = parseInt(price);
    },
    moneyChange() {
      const {
        price,
        accountInfo: { reward }
      } = this;
      if (!price || !+price) {
        this.errorMsg = i18n.t('upgrade_page_views_withdraw_index_1578');
        this.showPriceError = true;
        return;
        // } else if (price < 3000) {
      } else if (price < 1) {
        this.errorMsg = i18n.t('upgrade_page_views_withdraw_index_1579');
        this.showPriceError = true;
        return;
      } else if (price >= 10000) {
        this.errorMsg = i18n.t('upgrade_page_views_withdraw_index_1580');
        this.showPriceError = true;
        return;
      } else if (price > reward) {
        this.errorMsg = i18n.t('upgrade_page_views_withdraw_index_1581');
        this.showPriceError = true;
        return;
      }
      this.showPriceError = false;
    },
    open() {
      this.dialogVisible = true;
    }
  },
  created() {
    this.getWithdrawInfo();
  },
  beforeRouteEnter(to, from, next) {
    if (from.name === 'WithdrawAccount') {
      next(vm => {
        vm.addTabs();
        vm.withdrawTab = 'WithdrawBenefit';
      });
    } else {
      next(vm => {
        vm.addTabs();
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.page-container {
  background: #fff;
  margin-bottom: 40px;
  .page-title {
    display: flex;
    align-items: flex-end;
    border-bottom: 1px solid $color-button;
    height: 92px;
    .tab-one {
      width: 148px;
      height: 67px;
      margin-left: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      cursor: pointer;
      .tab-icon {
        background: url('~@/assets/image/icons/icon-frame.png') no-repeat center
          center / 100%;
        position: absolute;
        top: -5px;
        right: -10px;
        width: 36px;
        height: 20px;
        color: #fff;
        font-size: 12px;
        @include flex;
      }
      .tab-title {
        font-weight: 500;
        font-size: 22px;
        line-height: 31px;
        text-align: center;
        color: $color-gray-1;
      }
      .tab-tip {
        font-size: 12px;
        line-height: 17px;
        text-align: center;
        color: $color-gray-2;
      }
      &.active::after {
        content: '';
        width: 100%;
        height: 4px;
        position: absolute;
        left: 0;
        bottom: 0;
        background: $color-yellow;
        border-radius: 11px;
      }
    }
  }
  .page-content {
    padding: 32px 40px 80px;
  }
}
.finsh-wrap {
  height: 617px;
  display: flex;
  flex-direction: column;
  align-items: center;
  > p {
    margin-top: 20px;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #636d86;
    cursor: pointer;
  }
  .finsh-icon {
    width: 46px;
    height: 46px;
    border-radius: 50%;
    border: 4px solid #38ba7c;
    margin-top: 85px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .finsh-title {
    margin-top: 19px;
    margin-bottom: 32px;
    font-weight: 500;
    font-size: 22px;
    line-height: 31px;
    text-align: center;
    color: #333333;
  }
  .finsh-card-title {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: $color-gray-1;
    a {
      color: $color-link;
      cursor: pointer;
    }
  }
  .finsh-card {
    padding: 6px 12px;
    width: 434px;
    background: $color-light;
    border: 1px solid $color-split;
    box-sizing: border-box;
    border-radius: 4px;
    font-size: 13px;
    line-height: 26px;
    margin-top: 8px;
    color: $color-gray-2;
    display: flex;
    flex-wrap: wrap;
    text-align: left;
    .info-label {
      width: 98px;
    }
    .info-value {
      width: 300px;
    }
  }
  .back-btn {
    background: $color-yellow;
    border-radius: 50px;
    width: 168px;
    height: 48px;
    margin-top: 80px;
    font-weight: 500;
    font-size: 16px;
    line-height: 48px;
    text-align: center;
    letter-spacing: -0.000319808px;
    color: $color-gray-1;
  }
}
.money-wrap {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: $color-gray-1;
  margin-bottom: 42px;
  .money {
    margin-left: 12px;
    font-weight: 600;
    font-size: 22px;
    line-height: 26px;
    color: $color-orange;
  }
}
.input-wrap {
  margin-top: 14px;
  .input-title {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: $color-gray-1;
    text-align: left;
  }
  .input-content {
    margin-top: 8px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
    .money-error {
      position: absolute;
      top: 54px;
      left: 0;
      font-size: 14px;
      line-height: 20px;
      color: #ff0d0d;
    }
    input {
      width: 434px;
      height: 48px;
      padding: 14px 10px;
      background: $color-light;
      border: 1px solid $color-split;
      box-sizing: border-box;
      border-radius: 4px;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      caret-color: $color-link;
      &::placeholder {
        color: #cacaca;
      }
    }
    .tip-wrap {
      width: 371px;
      margin-left: 20px;
    }
    p {
      font-size: 13px;
      line-height: 18px;
      color: $color-gray-2;
    }
  }
  .lanxin-info {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
    .text-wrap {
      padding: 6px 12px;
      width: 434px;
      background: $color-light;
      border: 1px solid $color-split;
      box-sizing: border-box;
      border-radius: 4px;
      font-size: 13px;
      line-height: 26px;
      color: $color-gray-2;
      display: flex;
      flex-wrap: wrap;
      text-align: left;
      .info-label {
        width: 98px;
      }
      .info-value {
        width: 300px;
      }
    }
    .tip-wrap {
      width: 371px;
    }
  }
}
.add-lanxin-info {
  width: 434px;
  height: 48px;
  padding: 0 12px;
  background: $color-light;
  border: 1px solid $color-split;
  box-sizing: border-box;
  border-radius: 4px;
  display: flex;
  align-items: center;
  cursor: pointer;
  span {
    font-weight: 500;
    font-size: 13px;
    line-height: 18px;
    color: $color-gray-1;
    margin-left: 6px;
  }
}
.el-dialog__wrapper {
  & /deep/ .el-dialog {
    border-radius: 8px;
  }
  & /deep/ .el-dialog__body {
    padding: 0;
    padding-bottom: 60px;
    // padding: 0 30px 60px 30px;
    .divider_mthods {
      width: 100%;
      height: 1px;
      background: #ececec;
    }
    div {
      font-size: 14px;
      color: #333333;
      padding: 0 30px 0 30px;
      line-height: 20px;
      margin-bottom: 20px;
    }
  }
}
.read-rules {
  margin-top: 56px;
  display: flex;
  align-items: center;
  .circle-wrap {
    width: 16px;
    height: 16px;
    border: 1px solid $color-gray-3;
    box-sizing: border-box;
    box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.1);
    border-radius: 50%;
    margin-right: 8px;
    cursor: pointer;
    &.selected {
      border: none;
      background: $color-yellow;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .text {
    font-size: 14px;
    line-height: 20px;
    color: #666666;
    .light {
      color: $color-link;
      cursor: pointer;
    }
  }
}
.withdraw-btn {
  width: 168px;
  height: 48px;
  border-radius: 50px;
  background: $color-yellow;
  font-weight: 500;
  font-size: 16px;
  line-height: 48px;
  text-align: center;
  letter-spacing: -0.000319808px;
  color: $color-gray-1;
  margin-top: 20px;
  &:disabled {
    background: $color-button !important;
    font-weight: 500;
    font-size: 16px;
    color: rgba(99, 109, 134, 0.3) !important;
  }
}
</style>
